// 创建商务广告
import { useContext, useEffect, useMemo, useState } from "react"
import { CalendarContext, SelectDateRange } from "Components/Calendar/context"
import { Board, BoardModifyDialog } from "Types/board"
import { timeFormatStr } from "Methods/basic"
import { useInputChange } from "Hooks/basic"
import { useAddBoard, useUpdateBoard } from "Hooks/board"
import moment from "moment"
import { AppContext } from "Views/Home/context"


// 多条预约时的时间范围生成工具
export function useCreateModalTimeStr(selectDateRange: SelectDateRange | null) {
    return useMemo(() => {
        let modalTimeStr = ""
        const adTimes: number[] = []
        if (!selectDateRange) {
            return {
                adTimes: [],
                modalTimeStr: "",
            }
        }
        const dateRange = selectDateRange as SelectDateRange
        const startTime = Math.min(dateRange.start.getTime(), dateRange.end.getTime())
        const endTime = Math.max(dateRange.start.getTime(), dateRange.end.getTime())
        const startDate = new Date(startTime)
        const endDate = new Date(endTime)
        const startDay = startDate.getDay() || 7
        const endDay = endDate.getDay() || 7
        if (startTime === endTime) {
            modalTimeStr = `${moment(startDate).format(timeFormatStr.month)}`
        } else {
            modalTimeStr = `${moment(startDate).format(timeFormatStr.month)} - ${moment(endDate).format(timeFormatStr.month)}`
        }
        for (let i = 0; i <= endDay - startDay; i++) {
            adTimes.push(startTime + (i * 1000 * 3600 * 24))
        }
        return { modalTimeStr, adTimes }
    }, [selectDateRange])
}

type CreateType = "single" | "multiple"
export function useCreate(type: CreateType) {
    const {
        boardModifyDialog, handleChangeBoardModifyDialog,
        selectPlaceId, selectDateRange, resetPlaceId,
    } = useContext(CalendarContext)
    const dialogData = boardModifyDialog as BoardModifyDialog
    const { roleMap, activeMenu } = useContext(AppContext)
    const { isBusiness } = roleMap
    let adTimes: number[] = []
    let modalTimeStr = ""
    let placeId: number

    const notApp = activeMenu && activeMenu.name && !['主站APP日历'].includes(activeMenu.name)
    const value = useCreateModalTimeStr(selectDateRange)
    if (type === "single") {
        // 创建单个
        adTimes = [dialogData.date.getTime()]
        modalTimeStr = moment(dialogData.date).format(timeFormatStr.all)
        placeId = dialogData.place.id
    } else {
        // 创建多个
        adTimes = value.adTimes
        modalTimeStr = value.modalTimeStr
        placeId = selectPlaceId
    }
    const { text, handleChange, clearText } = useInputChange("")
    const { text: projectId, handleChange: handleProjectIdChange, clearText: clearProjectId, setText: setProjectId } = useInputChange("")
    const { text: projectMoney, handleChange: handleProjectMoneyChange, clearText: clearProjectMoney, setText: setProjectMoney } = useInputChange("")
    const { add } = useAddBoard()
    const callback = async () => {
        await add({
            name: text,
            ad_place_id: placeId,
            ad_times: adTimes,
            project_id: projectId || '',
            project_money: projectMoney || '',
        })
    }
    const cancelCallback = () => {
        handleChangeBoardModifyDialog(null)
        clearText()
        clearProjectId()
        clearProjectMoney()
        resetPlaceId()
    }
    const disabled = text === "" || (isBusiness && (projectId.length > 50 || projectMoney.length > 50 || !!(notApp && (projectId === ""))))
    return {
        callback, cancelCallback,
        dialogData, disabled, modalTimeStr,
        text, handleChange,
        projectId, handleProjectIdChange,
        projectMoney, handleProjectMoneyChange,
        isBusiness, notApp
    }
}
// 修改商务广告
export function useUpdate() {
    const {
        boardModifyDialog, handleChangeBoardModifyDialog,
    } = useContext(CalendarContext)
    const { roleMap, user } = useContext(AppContext)
    const { isBusiness } = roleMap
    const dialogData = boardModifyDialog as BoardModifyDialog
    const isMine = dialogData.board && dialogData.board.creator_id === user.uid
    const notApp = dialogData.board && !['pc站点', '移动站点', '果壳APP'].includes(dialogData.board.channel.name)
    const isPass = dialogData.isPass
    const board = dialogData.board as Board
    const { text, handleChange, clearText, setText } = useInputChange("")
    const { text: projectId, handleChange: handleProjectIdChange, clearText: clearProjectId, setText: setProjectId } = useInputChange("")
    const { text: projectMoney, handleChange: handleProjectMoneyChange, clearText: clearProjectMoney, setText: setProjectMoney } = useInputChange("")
    useEffect(() => {
        setText(board.name)
        setProjectId(board.project_id)
        setProjectMoney(board.project_money)
    }, [board, setText, setProjectId, setProjectMoney])
    const { update } = useUpdateBoard()
    const callback = async () => {
        await update({
            variables: {
                id: board.id,
                name: text,
                article_type_id: 0,
                content_type: "",
                is_lottery: false,
                is_micro: false,
                project_id: projectId || '',
                project_money: projectMoney || '',
            },
        })
    }
    const cancelCallback = () => {
        handleChangeBoardModifyDialog(null)
        clearText()
        clearProjectId()
        clearProjectMoney()
    }
    const dateStr = moment(dialogData.date).format(timeFormatStr.all)
    const disabled = text === "" || (isBusiness && (projectId.length > 50 || projectMoney.length > 50 || !!(notApp && (projectId === ""))))
    return {
        callback, cancelCallback,
        dialogData, disabled, dateStr,
        isBusiness, isMine, isPass, notApp,
        text, handleChange,
        projectId, handleProjectIdChange,
        projectMoney, handleProjectMoneyChange
    }
}
